import { Button, Input, Label } from "@/components/ui"
import { TooltipInfo } from "@/components/ui/TooltipInfo"
import { useEmailTypeSettings, useUpdateEmailTypeSettings } from "@/hooks/useEmailSettings"
import { useEffect } from "react"
import { useState } from "react"
import { Loader2 } from "lucide-react"
import { Example } from "./ExampleContent"

export const CancellationEmail = () => {
  const [subject, setSubject] = useState('');
  const [originalValues, setOriginalValues] = useState({ subjects: '' });
  const { data: email } = useEmailTypeSettings('cancel');
  const { mutate: updateEmailSettings, isPending } = useUpdateEmailTypeSettings();
  
  useEffect(() => {
    setSubject(email?.cancel?.subject || '');
    setOriginalValues({ subjects: email?.cancel?.subject || '' });
  }, [email]);

  const isChanged = subject.trim() !== originalValues.subjects.trim() && subject.trim() !== '';

  const cancel = () => {
    setSubject(originalValues.subjects);
  }

  return (  
    <div className="col-span-3">
      <h1 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">Email Cancellation Settings</h1>
      <p className="text-sm text-gray-500 dark:text-gray-400 italic mb-10">Clients will automatically receive a cancellation email after their appointment is cancelled.</p>

      <div className="flex flex-col gap-10">
        <div>
          <div className="flex items-center mb-1 gap-2">
            <Label htmlFor="subject" className="font-semibold text-gray-900 text-base">Subject</Label>
            <TooltipInfo description="Subject is the short headline of an email that the recipient sees in their inbox. It should briefly reflect the main idea of the email and encourage them to open it." />
          </div>
          <Input id="subject" placeholder="Subject" className="mt-1 h-12 block w-full" type="text" value={subject} onChange={(e) => setSubject(e.target.value)} />
        </div>

        <div>
          <div className="flex items-center mb-1 gap-2">
            <p  className="font-semibold text-gray-900 text-base">Timing</p>
            <TooltipInfo description="Timing defines how long before or after the event your email will be sent." />
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400 italic mb-10">Sends immediately after the appointment is cancelled.</p>
        </div>
      </div>
      <Example subject={subject} type="cancel" />
      {isChanged && 
        <div className="flex gap-2 mt-10">
          <Button 
            variant="default" 
            className="w-[100px]" 
            onClick={()=> updateEmailSettings({ type: 'cancel', settings: { subject } })} 
            disabled={isPending}
          >
            {isPending 
              ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" />Save</>) 
              : ('Save')
            }
          </Button>
          <Button variant="outline" className="px-6" onClick={cancel}>
            Cancel
          </Button>
        </div>
      }

    </div>
  )
}